export default {"src":"/_next/static/media/fire_extinguisher.96a20d7e.svg","height":100,"width":100};